module.exports = __webpack_public_path__ + "img/js.0031238c.svg";